import { gql } from '@apollo/client';

const QUERY_LIVE_POSITION = gql`
subscription livePositionList {
  clubmate_usersregister_userliveposition(where:{ _and: {is_active: {_eq: true}},is_out_of_circle_area:{_eq:false}}) {
    id
    usersregister_userregister {
      id
      name
      surname
      fiscal_code
    }
    lat
    lng
    is_active
    last_update
  }
}
`

const QUERY_GET_AREA_COORDS=gql`
subscription areaCoords{
  clubmate_clubmatearea_clubmatearea{
    name
    coordinate
  }
}
`

export {QUERY_LIVE_POSITION,QUERY_GET_AREA_COORDS};